<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-xl-table-popover">
    <template v-if="textList?.length">
      <!-- 列表 -->
      <template v-if="textList?.length > 1">
        <jw-overflow-list min="1" class="popover-over-list" v-if="sourceType === 1">
          <!-- 列表 -->
          <template #overflow="{ number }">
            <jw-tooltip content-class="jw-tooltip-scroll" :content-style="{ maxWidth: '300px', padding: '8px 6px 0 12px' }">
              <jw-tag class="hand" size="small">+{{ number }}</jw-tag>
              <template #content>
                <div class="scope-wide-item-avatar">
                  <jw-space wrap>
                    <div class="scope-wide-item-avatar-name" v-for="(item, index) in getOverflowItems(number)" :key="index">
                      <jw-tag class="popover-tag" size="small" :color="getBackground(item)?.background || 'var(--color-fill-2)'" :style="{ color: getBackground(item)?.color || 'var(--color-text-1)', wordBreak: 'break-all', whiteSpace: 'normal', height: 'auto' }">{{ item }}</jw-tag>
                    </div>
                  </jw-space>
                </div>
              </template>
            </jw-tooltip>
          </template>
          <jw-tag
            v-for="(item, index) in textList"
            :key="index"
            size="small"
            :class="['popover-tag', 'content-tag', 'single-tag']"
            :color="getBackground(item)?.background || 'var(--color-fill-2)'"
            :style="{
              color: getBackground(item)?.color || 'var(--color-text-1)'
            }"
          >
            <fh-ellipsis :content="item" />
          </jw-tag>
        </jw-overflow-list>
        <template v-else>
          <!-- 详情 -->
          <div class="detail-multi-tag">
            <jw-tag v-for="(jItem, jIndex) in textList" :key="jIndex" size="small" :class="['popover-tag', 'single-tag']" :color="getBackground(jItem)?.background || 'var(--color-fill-2)'" :style="{ color: getBackground(jItem)?.color || 'var(--color-text-1)' }"><fh-ellipsis :content="jItem" /></jw-tag>
          </div>
        </template>
      </template>
      <template v-else>
        <jw-tag
          v-for="(item, index) in textList"
          :key="index"
          size="small"
          :class="['popover-tag', 'single-tag']"
          :color="getBackground(item)?.background || 'var(--color-fill-2)'"
          :style="{
            color: getBackground(item)?.color || 'var(--color-text-1)'
          }"
        >
          <fh-ellipsis :content="item" />
        </jw-tag>
      </template>
    </template>
    <template v-else>
      {{ newFieldValue?.length > 0 && newFieldValue && newFieldValue !== '[]' ? newFieldValue : '-' }}
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';

// import { ref } from 'vue';
// console.log('1-开始创建组件-setup');
// const data = reactive({});
// const name = ref();

const props = defineProps({
  styleInfo: {
    type: Object
  },
  value: {
    type: String
  },
  sourceType: {
    type: Number,
    default: 1 // 1:列表 2:详情
  }
});

const newFieldValue = computed(() => props.value);

const textList = computed(() => {
  const value = props.value;
  if (typeof value === 'string' && value.trim().length > 0) {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }
  return [];
}); // 字段列表
const recordStyle = computed(() => (props.styleInfo ? JSON.parse(props.styleInfo) : null)); // 字段配置数组

const getBackground = (label) => {
  return recordStyle.value?.find((styleItem) => styleItem.label === label);
};

// 获取溢出的标签项
const getOverflowItems = (number) => {
  if (!number || typeof number !== 'number' || number <= 0) {
    return [];
  }
  // 确保number是一个正整数
  const count = Math.floor(number);
  // 返回最后count个元素
  return textList.value.slice(-count);
};
</script>
<style scoped lang="less">
@import './xl-table-popover.less';
</style>
